import axiosClient from "./axiosClient";

const receiveService = {
  getLitOPD: async (params) => {
    const url = "/qlkhambenh/phieu-kham/bao-cao-opd";
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },

  //crud đoàn khám
  getLitGroup: async () => {
    const url = "/qlkhambenh/dm-doan-kham/list-dm-doan-kham";
    const response = await axiosClient.get(url);
    return response.data;
  },
  postLitGroup: async (data) => {
    const url = "/qlkhambenh/dm-doan-kham";
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  deletetLitGroup: async (id) => {
    const url = `/qlkhambenh/dm-doan-kham?id=${id}`;
    const response = await axiosClient.delete(url);
    return response.data;
  },
  putLitGroup: async (data) => {
    const url = `/qlkhambenh/dm-doan-kham?id=${data.id}`;
    const response = await axiosClient.put(url, data);
    return response.data;
  },

  //lấy cho tiết phiếu khám
  getPKById: async (id) => {
    const url = `/qlkhambenh/phieu-kham?id=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },

  //Kí bảo mật

  //Post chữ kí
  postSignSecure: async (data) => {
    const url = `/qlkhambenh/phieu-kham/dang-ky-bao-mat/phieu-dang-ky-bao-mat`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  // lấy chữ kí của BN cần kí
  getSignByPatient: async () => {
    const url = `/qlkhambenh/phieu-kham/dang-ky-bao-mat/thong-tin-benh-nhan-can-ky`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  // lấy bb đã kí (PDF)
  getPDFByPatient: async (id) => {
    const url = `/qlkhambenh/phieu-kham/dang-ky-bao-mat/pdf?id_benh_nhan=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  // lấy bb đã kí (PDF)
  requireSignSecure: async (id) => {
    const url = `/qlkhambenh/phieu-kham/dang-ky-bao-mat/yeu-cau-ky-bao-mat?id=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getImgByPatient: async (id) => {
    const url = `/qlkhambenh/phieu-kham/dang-ky-bao-mat/get-by-id-benh-nhan?id=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },

  //upload file
  uploadFileResultSignSecure: async (id_benh_nhan, data) => {
    const url = `/qlkhambenh/phieu-kham/dang-ky-bao-mat/upload-phieu-dang-ky-bao-mat`;
    const headers = { "Content-Type": "multipart/form-data" };
    const response = await axiosClient.post(url, data, {
      params: { id_benh_nhan },
      headers: headers,
    });
    return response.data;
  },

  //post mapping tk hiện tại với tk ký
  postLinkAccount: async (data) => {
    const url = `/qlkhambenh/dm-tai-khoan-ky-bao-mat`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  //lấy danh sách tài khoản
  getLinkAccount: async () => {
    const url = `/qlkhambenh/dm-tai-khoan-ky-bao-mat/list-all`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  //Xoá tài khoản đã liên kết
  deleteLinkAccount: async (id) => {
    const url = `/qlkhambenh/dm-tai-khoan-ky-bao-mat?id=${id}`;
    const response = await axiosClient.delete(url);
    return response.data;
  },

  //crud marketing
  getLitMkt: async () => {
    const url = "/qlkhambenh/dm-nguon-marketing/list-dm-nguon-marketing";
    const response = await axiosClient.get(url);
    return response.data;
  },
  postLitMkt: async (data) => {
    const url = "/qlkhambenh/dm-nguon-marketing";
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  deletetLitMkt: async (id) => {
    const url = `/qlkhambenh/dm-nguon-marketing?id=${id}`;
    const response = await axiosClient.delete(url);
    return response.data;
  },
  putLitMkt: async (data) => {
    const url = `/qlkhambenh/dm-nguon-marketing?id=${data.id}`;
    const response = await axiosClient.put(url, data);
    return response.data;
  },
};

export default receiveService;
